export default __webpack_public_path__ + "static/media/GroovingImg.6b2672d5.jpg";